export default "/static/webpack/media/undraw_completed_tasks.8123d2ab.svg";